module.exports = __webpack_public_path__ + "img/male-youngadult-head.38149801.svg";